type UserEventListener = (data: unknown, event?: MessageEvent) => void;

const userEventListeners = new Set<UserEventListener>();

export function subscribeGlobalUserEvent(listener: UserEventListener) {
  userEventListeners.add(listener);
  return () => userEventListeners.delete(listener);
}

export function publishGlobalUserEvent(data: unknown, event?: MessageEvent) {
  userEventListeners.forEach((listener) => listener(data, event));
}
